export const Loading = { kind: 'loading' };
export const Missing = { kind: 'missing' };
export const Loaded = (value) => ({
    kind: 'loaded',
    value,
});
/**
 * Read a resource from a `Record<string, T | null | undefined>`-shaped map,
 * returning a tagged value that forces callers to switch on the state. The
 * three raw-map conventions this encodes:
 *
 * - key absent (`!(id in map)` or `map == null`) → `Loading`
 * - key present with `null`  (looked up, no match) → `Missing`
 * - key present with `undefined` (seeded, still fetching) → `Loading`
 * - key present with `T` → `Loaded(value)`
 *
 * The point of the wrapper is to end the subtle `null ?? undefined` class of
 * bugs where a "deleted" signal from the loader gets collapsed into
 * "loading" by an upstream caller.
 */
export function resolveAsyncRef(map, id) {
    if (!id)
        return Missing;
    if (map == null)
        return Loading;
    if (!(id in map))
        return Loading;
    const value = map[id];
    if (value === null)
        return Missing;
    if (value === undefined)
        return Loading;
    return { kind: 'loaded', value };
}
//# sourceMappingURL=async-resource.js.map